/**
 * 全局时间工具
 * 后端 BJDatetime 已将所有 datetime 字段序列化为北京时间字符串（如 "2026-05-19 23:30:00"）
 * 前端直接显示即可，不再手动 +8h
 */

/**
 * 格式化北京时间字符串（后端已返回北京时间，直接返回）
 */
export function formatBJ(str) {
  if (!str) return '-';
  if (typeof str !== 'string') return String(str);
  return str;
}

/**
 * 北京时间字符串 → 短日期（M月D日）
 */
export function formatBJShort(str) {
  if (!str || typeof str !== 'string') return '未知';
  // 支持 "2026-05-19 23:30:00" 或 "2026-05-19T23:30:00" 格式
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${parseInt(m[2], 10)}月${parseInt(m[3], 10)}日`;
  return '未知';
}

/**
 * 北京时间字符串 → 日期key（YYYY-MM-DD）
 */
export function getBJDateKey(str) {
  if (!str || typeof str !== 'string') return 'unknown';
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str.substring(0, 10);
  return 'unknown';
}

/**
 * 北京时间字符串 → 短日期（MM-DD）
 */
export function formatBJDate(str) {
  if (!str || typeof str !== 'string') return '';
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[2]}-${m[3]}`;
  return '';
}

/**
 * 兼容：返回 Date 对象（不再 +8h）
 */
export function utcToDate(str) {
  if (!str) return null;
  const d = new Date(str.includes('T') ? str : str.replace(' ', 'T'));
  return isNaN(d.getTime()) ? null : d;
}
